import { render, staticRenderFns } from "./ProdImageEditorDrawer.vue?vue&type=template&id=16669ac8&scoped=true"
import script from "./ProdImageEditorDrawer.vue?vue&type=script&lang=js"
export * from "./ProdImageEditorDrawer.vue?vue&type=script&lang=js"
import style0 from "./ProdImageEditorDrawer.vue?vue&type=style&index=0&id=16669ac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16669ac8",
  null
  
)

export default component.exports